$(document).ready(function(){
    $(document).on('click', '.apartment-row', function(e) {
        var apartment_id = $(this).attr('data-id');

        var values='type=get-info';
        values+='&id=' + apartment_id;

        var url = 'get-info-modal'+"/"+apartment_id+"/"+0;
        if ($(window).width() < 991)
        {
            url = 'get-info-modal'+"/"+apartment_id+"/"+1;
        }
        $.ajax({
            type: "GET",
            url: baseURL + "/apartments/"+url,
            data: values,
            success: function(html) {
                if (html == 'invalid-id') {
                    alert('Invalid item ID!'); return false;
                }
                if (html == 'saving-error') {
                    alert('Error! Please contact an administrator!'); return false;
                }

                $('.apartment-row').removeClass('active');
                $('#apartment-row-' + apartment_id).addClass('active');

                if ($(window).width() > 768)
                {
                    $('#apartments-details-wrapper').hide();
                    $('#apartment-details-wrapper').html(html);
                } else
                {
                    // $('#apartments-details-wrapper').hide();
                    // $(".location-content").slideUp("slow");
                    // $('#apartment-details-wrapper').html(html);
                    $('#appDetailsModal').html(html);
                    $('#appDetailsModal').modal('show');
                }

            }
        });

    });

    $(document).on('change', '#building, #apartment_type, #price_range', function(e) {
        var building = $('#building').val();
        var apartment_type = $('#apartment_type').val();
        var price_range = $('#price_range').val();
        var project_id = $('#project_id').val();
        var values='type=search-apartment';
        values+='&building=' + building;
        values+='&apartment_type=' + apartment_type;
        values+='&price_range=' + price_range;
        values+='&project_id=' + project_id;
        $.ajax({
            type: "GET",
            url: baseURL + "/apartments/search",
            data: values,
            success: function(html) {
                if (html == 'invalid-id') {
                    alert('Invalid item ID!'); return false;
                }
                if (html == 'saving-error') {
                    alert('Error! Please contact an administrator!'); return false;
                }

            	$('.table-wrapper').html(html);

				if ($(".table-lightbox").length > 0) {
			        $('[data-lightbox]').each(function(index, element) {
			            if (element.children.length > 0) {
			                var lightboxSlider = $(element.children).simpleLightbox({
			                    navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>']
			                });
			            }
			        });
			    }

            }
        });
    });


    $(document).on('click', '#download_doc_btn, .opnDocMod', function(e) {
        e.preventDefault();
        var id = $(this).attr('data-id');
        if (!id) { alert('Invalid ID!'); return false; }

        var values='';
        values+='id=' + id;

        $.ajax({
            type: "GET",
            url: baseURL + "/projects/show-documents",
            data: values,
            success: function(html) {
                if (html == 'invalid-project-id') { alert('Invalid project ID!'); return false; }
                if (html == 'invalid-documents') { alert('Documents not found!'); return false; }

                $('#project-modal').html(html);
                $('#project-modal').modal('show');
            }
        });
    });

});
